import { useEffect, useState } from 'react';
import { streamV2 } from '@services/context';
import { Status } from '@services/StreamV2';

export function useStreamV2Status(): Status {
  const [status, setStatus] = useState<Status>(streamV2.status);

  useEffect(() => {
    const unsubscribe = streamV2.onStatusChange(setStatus);
    setStatus(streamV2.status);
    return unsubscribe;
  }, []);

  return status;
}
